export default __webpack_public_path__ + "static/Mapview-6a877d1274e228c54b0e57099fad228c.png";